import React from 'react';

/**
 * Wrapper component for draggable blocks in the website builder.
 */
class BuilderBlock extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        switch (nextProps.dataType) {
            case 'layout':
            case 'layout-horizontal':
            case 'layout-vertical':
                return true;
        }
        return !nextProps.dragging;
    }

    handleClick(event) {
        if (event) {
            event.stopPropagation();
        }
        if (this.props.onBlockClick) {
            this.props.onBlockClick(this.props.blockId);
        }
    }

    render() {
        const props = this.props;
        let className = 'builder-block draggable';
        if (props.active) {
            className += ' draggable-active';
        }
        let dragOutline;
        switch (props.dataType) {
            case 'layout':
            case 'layout-horizontal':
            case 'layout-vertical':
                className += ' layout';
                break;
            default:
                dragOutline = <div className="drag-outline" />;
                break;
        }
        if (props.className) {
            className += ` ${props.className}`;
        }
        const style = props.style;
        if (style && style.maxWidth) {
            style.width = '100%';
        }
        return (
            <div
                className={className}
                data-block-type={props.blockType}
                data-type={props.dataType}
                draggable={true}
                id={props.blockId}
                style={style}
                onClick={this.handleClick}
                onDragEnter={props.onDragEnter}
                onDragStart={props.onDragStart}>
                {props.children}
                {dragOutline}
            </div>
        );
    }
}

export default BuilderBlock;

